import {DOMINOES} from 'redux/actionTypes';

const initialState = {
	dominoes: false,
	fetching: false
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case DOMINOES.ADD_DOMINO_LOCAL: {
			let {domino} = action.payload;
			let dominoes = [...state.dominoes];
			dominoes.push({
				color: {
					color: domino.colorCode,
					id: domino.colorId
				},
				group: {
					id: domino.groupId,
					name: domino.groupName,
				},
				x: domino.x,
				y: domino.y
			});
			return {
				...state,
				dominoes
			};
		}
		case DOMINOES.LOADING: {
			let {
				payload = {
					fetching: true
				}
			} = action;
			return {
				...state,
				fetching: payload.fetching
			};
		}
		case DOMINOES.SET: {
			let {dominoes} = action.payload;
			return {
				...state,
				dominoes,
				fetching: false
			};
		}

		case DOMINOES.ADD: {
			let {domino} = action.payload;
			let dominoes = [...state.dominoes];
			dominoes.push(domino);

			return {
				...state,
				dominoes
			};
		}
		default:
			return state;
	}
};

export default reducer;
